import type { JSX, ReactNode } from 'react';
import styles from './ActOnSettlementSection.module.scss';

interface ActOnSettlementSectionProps {
  title: string;
  children: ReactNode;
}

export const ActOnSettlementSection = ({ title, children }: ActOnSettlementSectionProps): JSX.Element => {
  return (
    <>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </>
  );
};
